import { useEffect, useRef } from 'react';

import confetti from 'canvas-confetti';

export const Confetti = ({ children }: { children: React.ReactNode }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const canvas = document.createElement('canvas');
    canvas.style.position = 'absolute';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';

    containerRef.current.appendChild(canvas);
    canvasRef.current = canvas;

    const containerConfetti = confetti.create(canvas, { resize: true });

    const colors = ['#990d73', '#00ff00', '#56abd0', '#0affff', '#0b2fa1', '#4bc493', '#ffea00', '#ff00b8'];
    let i = 0;

    function snow() {
      containerConfetti({
        particleCount: 1,
        startVelocity: 0,
        ticks: 300,
        origin: { x: Math.random(), y: 0 },
        colors: [colors[i]],
        shapes: ['square'],
        gravity: 0.6,
        scalar: 1.2
      });

      i = (i + 1) % colors.length;
      setTimeout(snow, 150);
    }

    snow();

    return () => {
      canvas.remove();
    };
  }, []);

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      {children}
    </div>
  );
};
